module.exports = __webpack_public_path__ + "static/our_products.499cb5ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/our_products.png
// module id = 659
// module chunks = 132207355946902